import React, { useEffect, useRef, useState } from 'react';
import './Hero.css';

const Hero = () => {
  const videoRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [shouldMute, setShouldMute] = useState(false);
  const [autoplayRejected, setAutoplayRejected] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const playWithAudio = async () => {
      try {
        video.muted = false;
        await video.play();
      } catch (err) {
        setAutoplayRejected(true);
        setShouldMute(true);
      }
    };

    playWithAudio();
  }, []);

  useEffect(() => {
    if (!autoplayRejected) return;
    const attemptUnlock = () => {
      const video = videoRef.current;
      if (!video) return;
      video.muted = false;
      video.play()
        .then(() => {
          setAutoplayRejected(false);
          const scrolledAway = window.scrollY > 50;
          setShouldMute(scrolledAway);
        })
        .catch(() => {});
    };

    document.addEventListener('pointerdown', attemptUnlock);
    document.addEventListener('keydown', attemptUnlock);
    return () => {
      document.removeEventListener('pointerdown', attemptUnlock);
      document.removeEventListener('keydown', attemptUnlock);
    };
  }, [autoplayRejected]);

  useEffect(() => {
    const handleScroll = () => {
      const scrolledAway = window.scrollY > 50;
      setShouldMute(scrolledAway || autoplayRejected);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [autoplayRejected]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = shouldMute;
    if (!shouldMute) {
      video.play().catch(() => {});
    }
  }, [shouldMute]);

  return (
    <section className="hero">
      <video
        ref={videoRef}
        className="hero-video"
        autoPlay
        loop
        playsInline
        preload="auto"
        poster="https://images.unsplash.com/photo-1506905925346-14bda5d4c4c0?auto=format&fit=crop&w=2070&q=80"
        // muted={shouldMute}
      >
        <source src="/amoda_hero.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="hero-overlay"></div>

      {/* Navigation */}
      <nav className="hero-nav">
        <div className="hero-logo">
          <img 
            src="/glob_stay_logo.png" 
            alt="Glob Stay Logo" 
            className="logo-image"
          />
        </div>

        <div
          className="hamburger"
          onClick={toggleMenu}
          role="button"
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleMenu(); } }}
        >
          <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
        </div>

        <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
          <a href="/about" className="mobile-nav-link" onClick={toggleMenu}>About</a>
          <a href="#" className="mobile-nav-link" onClick={toggleMenu}>Amenities</a>
          <a href="#" className="mobile-nav-link" onClick={toggleMenu}>Book a stay</a>
          <a href="#" className="mobile-nav-link" onClick={toggleMenu}>Contact</a>
        </div>
      </nav>

      {/* Main Content */}
      <div className="hero-content">
        <p className="hero-tagline">Luxury Rooted in Serenity.</p>
        <h1 className="hero-title">AMODA SARI</h1>
        <a href="#vision-in-motion" className="hero-button">
          Explore the Vision <span className="arrow">→</span>
        </a>
      </div>

      {/* Curated by AGF Text */}
      <div className="hero-credit">
        <p>Curated by AGF</p>
      </div>

    </section>
  );
};

export default Hero;
